import React from "react";
import TestImage from "../assets/panel_surya_rent.jpg"

export function ContentWork({title, subtitle, description}) {
    return (
        <>
            <div>
                <div className="lg:flex lg:max-w-full lg:my-8 my-8 w-full">
                    <img src={TestImage} alt=''
                        className="w-1/1 lg:w-1/6 rounded-md" />
                    <div className="lg:p-6 lg:ml-8 lg:mt-0 mt-6">
                        <h2 className="mb-2 text-2xl font-bold text-gray-900">{title}</h2>
                        <h4 className="mb-2 text-sm font-bold text-blue-400">{subtitle}</h4>
                        <p className ="text-gray-600">{description}</p>
                    </div>
                </div>
            </div>
        </>
    )
}